var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoFunny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 22.4983C19 22.4983 22.4983 17.7977 22.4983 11.9992C22.4983 6.20064 19 1.5 11.9992 1.5C4.99833 1.5 1.5 6.20064 1.5 11.9992C1.5 17.7977 4.99833 22.4983 11.9992 22.4983Z",
    fill: "#FFB02E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73635 8.39315C6.77241 8.20769 6.85496 7.98038 7.0119 7.80939C7.1464 7.66286 7.38542 7.5 7.87514 7.5C8.35643 7.5 8.60155 7.66624 8.74306 7.82159C8.90667 8.0012 8.98549 8.23026 9.0112 8.37832C9.08207 8.78643 9.47035 9.05981 9.87846 8.98894C10.2866 8.91807 10.56 8.52979 10.4891 8.12168C10.4298 7.78048 10.2601 7.25955 9.85196 6.81147C9.4217 6.33913 8.7718 6 7.87514 6C6.98691 6 6.3397 6.32347 5.90682 6.7951C5.49638 7.24228 5.33041 7.76496 5.26393 8.10685C5.18487 8.51345 5.45039 8.90715 5.85699 8.98621C6.26359 9.06527 6.65729 8.79975 6.73635 8.39315Z",
    fill: "#402A32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9865 8.39315C15.0226 8.20769 15.1051 7.98038 15.2621 7.80939C15.3966 7.66286 15.6356 7.5 16.1253 7.5C16.6066 7.5 16.8517 7.66624 16.9932 7.82159C17.1569 8.0012 17.2357 8.23026 17.2614 8.37832C17.3323 8.78643 17.7205 9.05981 18.1286 8.98894C18.5367 8.91807 18.8101 8.52979 18.7393 8.12168C18.68 7.78048 18.5103 7.25955 18.1021 6.81147C17.6719 6.33913 17.022 6 16.1253 6C15.2371 6 14.5899 6.32347 14.157 6.7951C13.7466 7.24228 13.5806 7.76496 13.5141 8.10685C13.4351 8.51345 13.7006 8.90715 14.1072 8.98621C14.5138 9.06527 14.9075 8.79975 14.9865 8.39315Z",
    fill: "#402A32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.75C5.25 18.75 5.25 12 5.25 12H18.75C18.75 12 18.75 18.75 12 18.75Z",
    fill: "#BB1D80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.375V12H18V12.375C18 12.7892 17.6642 13.125 17.25 13.125H6.75C6.33579 13.125 6 12.7892 6 12.375Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47283 15.2773L6.00018 12.75C6.6215 12.1287 6.6215 11.1213 6.00018 10.5C5.37886 9.87867 4.3715 9.87867 3.75018 10.5L1.22283 13.0273C0.637733 13.6124 0.598804 14.5484 1.13329 15.18C1.73453 15.8906 2.81466 15.9355 3.47283 15.2773Z",
    fill: "#3F5FFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7151 15.2773L18.1877 12.75C17.5664 12.1287 17.5664 11.1213 18.1877 10.5C18.8091 9.87867 19.8164 9.87867 20.4377 10.5L22.9651 13.0273C23.5502 13.6124 23.5891 14.5484 23.0546 15.18C22.4534 15.8906 21.3733 15.9355 20.7151 15.2773Z",
    fill: "#3F5FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoFunny);
export default __webpack_public_path__ + "static/media/so-funny.5fce1b2f90f9ef2ff14f83ac46264bc0.svg";
export { ForwardRef as ReactComponent };